// extracted by mini-css-extract-plugin
export default {"customScrollbar":"pomocode_customScrollbar__HwGSg"};